import { Flex, keyframes, styled } from '@withjoy/joykit';

const marquee = keyframes`
  from {
    transform: translate3d(0px, 0px, 0px);
  }
  to {
    transform: translate3d(-50%, 0px, 0px);
  }
`;

export const MarqueeContainer = styled(Flex)`
  animation: ${marquee} 30s linear 0s infinite normal none running;
`;
